const buildSeries = (label, color, values, area = false) => ({
  label,
  color,
  values,
  area,
});

export const RETAIL_REPORTS = [
  {
    id: 'sales-hierarchy',
    path: '/retail-reports/sales-hierarchy',
    name: 'Bán hàng theo chi nhánh',
    permission: 'SL_SALES_REPORT_HIERARCHY_VIEW',
    menuIcon: 'fi fi-rr-chart-histogram',
    subtitle: 'Tổng hợp doanh thu từ tổng công ty đến chi nhánh, cửa hàng và từng ngày.',
    filters: [], metrics: [], panels: [],
  },
  {
    id: 'overview',
    path: '/retail-reports/overview',
    name: 'Tổng quan bán hàng',
    permission: 'SL_SALES_REPORT_OVERVIEW_VIEW',
    menuIcon: 'fi fi-rr-apps',
    subtitle: 'Theo dõi doanh thu, đơn hàng, khách hàng và hiệu suất nhân viên trong phạm vi được phân quyền.',
    filters: [
      { label: 'Kỳ báo cáo', value: '30 ngày gần nhất' },
      { label: 'Phạm vi', value: 'Toàn hệ thống' },
      { label: 'Kênh', value: 'Cửa hàng + Online' },
      { label: 'So sánh', value: 'Cùng kỳ năm trước' },
    ],
    metrics: [
      { label: 'Doanh thu thuần', value: '48,6 tỷ', delta: '+12,4%', tone: 'positive', note: 'so với cùng kỳ' },
      { label: 'Biên lợi nhuận gộp', value: '24,8%', delta: '+1,6 điểm', tone: 'positive', note: 'sau khuyến mại' },
      { label: 'Hóa đơn bình quân', value: '3,82 triệu', delta: '+4,2%', tone: 'positive', note: 'AOV toàn hệ thống' },
      { label: 'Tỷ lệ chuyển đổi', value: '31,5%', delta: '-0,8 điểm', tone: 'warning', note: 'khách vào / hóa đơn' },
    ],
    panels: [
      {
        type: 'line',
        width: 'span-8',
        title: 'Doanh thu 12 tuần gần nhất',
        subtitle: 'So sánh doanh thu thuần giữa chuỗi cửa hàng và online.',
        labels: ['W01', 'W02', 'W03', 'W04', 'W05', 'W06', 'W07', 'W08', 'W09', 'W10', 'W11', 'W12'],
        series: [
          buildSeries('Cửa hàng', '#ED3237', [6.2, 6.6, 6.5, 6.9, 7.4, 7.8, 7.5, 8.1, 8.5, 8.2, 8.6, 9.0], true),
          buildSeries('Online', '#344054', [2.1, 2.4, 2.6, 2.7, 2.9, 3.2, 3.4, 3.5, 3.7, 3.8, 4.0, 4.2]),
        ],
        footer: 'Cửa hàng flagship Hà Nội, Cầu Giấy và Hải Phòng đóng góp 56% tăng trưởng tuần 12.',
      },
      {
        type: 'donut',
        width: 'span-4',
        title: 'Cơ cấu doanh thu',
        subtitle: 'Tỷ trọng theo kênh bán và dịch vụ đi kèm.',
        segments: [
          { label: 'Showroom', value: 52, color: '#ED3237' },
          { label: 'Online', value: 19, color: '#344054' },
          { label: 'Dự án', value: 17, color: '#F79009' },
          { label: 'Phụ kiện', value: 12, color: '#12B76A' },
        ],
      },
      {
        type: 'table',
        width: 'span-8',
        title: 'Top cửa hàng theo doanh thu',
        subtitle: 'Ưu tiên theo doanh thu thuần, biên lợi nhuận và tăng trưởng.',
        columns: ['Cửa hàng', 'Doanh thu', 'Biên gộp', 'Tăng trưởng'],
        rows: [
          ['Flagship Hà Nội', '9,4 tỷ', '26,2%', '+15,8%'],
          ['Showroom Cầu Giấy', '7,8 tỷ', '24,9%', '+11,5%'],
          ['Showroom Hải Phòng', '6,6 tỷ', '25,4%', '+18,1%'],
          ['Showroom Thanh Hóa', '5,1 tỷ', '22,6%', '+7,4%'],
        ],
      },
      {
        type: 'alerts',
        width: 'span-4',
        title: 'Điểm điều hành',
        subtitle: 'Khuyến nghị nhanh cho đội vận hành và bán lẻ.',
        items: [
          { tone: 'danger', title: 'Online conversion giảm', text: 'Landing loa kéo giảm 2,3 điểm do tỷ lệ bỏ giỏ tăng ở khung 20h-22h.' },
          { tone: 'warning', title: 'Tồn phụ kiện mic tăng', text: 'Mic karaoke không dây tồn > 42 ngày tại 3 cửa hàng miền Bắc.' },
          { tone: 'positive', title: 'Combo gia tăng tốt', text: 'Tỷ lệ bán kèm micro cho loa JBL Stage 320 đạt 37%, cao nhất từ đầu quý.' },
        ],
      },
    ],
  },
  {
    id: 'revenue-by-store',
    path: '/retail-reports/revenue-by-store',
    name: 'Bán hàng theo cửa hàng',
    permission: 'SL_RETAIL_REVENUE_BY_STORE_VIEW',
    menuIcon: 'fi fi-rr-shop',
    subtitle: 'So sánh năng lực bán của từng cửa hàng theo doanh thu, đơn ghi nhận doanh số và biên lợi nhuận.',
    filters: [
      { label: 'Khu vực', value: 'Miền Bắc' },
      { label: 'Cửa hàng', value: '12 chi nhánh' },
      { label: 'Kỳ', value: 'Theo tháng' },
      { label: 'Chỉ tiêu', value: 'Doanh thu + đơn hàng' },
    ],
    metrics: [
      { label: 'Doanh thu/cửa hàng', value: '4,05 tỷ', delta: '+8,2%', tone: 'positive', note: 'bình quân tháng' },
      { label: 'Khách vào showroom', value: '28.450', delta: '+6,9%', tone: 'positive', note: 'so với tháng trước' },
      { label: 'Tỷ lệ chuyển đổi', value: '29,8%', delta: '-1,1 điểm', tone: 'warning', note: 'khách vào -> hóa đơn' },
      { label: 'Doanh thu/m²', value: '18,6 triệu', delta: '+2,9%', tone: 'positive', note: 'hiệu suất mặt bằng' },
    ],
    panels: [
      {
        type: 'bars',
        width: 'span-6',
        title: 'Doanh thu theo cửa hàng',
        subtitle: 'Tỷ đồng / tháng.',
        bars: [
          { label: 'Hà Nội', value: 9.4, color: '#ED3237' },
          { label: 'Cầu Giấy', value: 7.8, color: '#FF6B6F' },
          { label: 'Hải Phòng', value: 6.6, color: '#FF8A70' },
          { label: 'Thanh Hóa', value: 5.1, color: '#F79009' },
          { label: 'Bắc Ninh', value: 4.7, color: '#344054' },
          { label: 'Online Hub', value: 4.2, color: '#12B76A' },
        ],
      },
      {
        type: 'line',
        width: 'span-6',
        title: 'Lưu lượng khách & tỷ lệ chuyển đổi',
        subtitle: 'Khách vào / hóa đơn trong 8 tuần gần nhất.',
        labels: ['W05', 'W06', 'W07', 'W08', 'W09', 'W10', 'W11', 'W12'],
        series: [
          buildSeries('Khách vào', '#344054', [19, 20, 22, 23, 22, 25, 27, 28]),
          buildSeries('Chuyển đổi', '#ED3237', [31, 32, 31, 30, 31, 30, 30, 29]),
        ],
        footer: 'Hải Phòng tăng khách tốt nhưng chuyển đổi thấp hơn bình quân hệ thống 2,4 điểm.',
      },
      {
        type: 'table',
        width: 'span-12',
        title: 'Hiệu suất cửa hàng',
        subtitle: 'Ưu tiên quyết định nhân sự, layout trưng bày và ngân sách marketing địa phương.',
        columns: ['Cửa hàng', 'Khách vào', 'Hóa đơn', 'Tỷ lệ chốt', 'Doanh thu/m²', 'Ghi chú'],
        rows: [
          ['Flagship Hà Nội', '6.820', '2.168', '31,8%', '22,1 triệu', 'Ổn định, có thể mở thêm khu trải nghiệm'],
          ['Cầu Giấy', '5.904', '1.912', '32,4%', '19,8 triệu', 'Lead từ digital chuyển đổi tốt'],
          ['Hải Phòng', '4.988', '1.364', '27,3%', '18,5 triệu', 'Cần đào tạo chốt combo'],
          ['Thanh Hóa', '3.456', '1.026', '29,7%', '15,9 triệu', 'Đang cải thiện sau đổi layout'],
          ['Bắc Ninh', '3.112', '952', '30,6%', '17,3 triệu', 'Nên tăng SKU âm thanh gia đình'],
        ],
      },
    ],
  },
  {
    id: 'margin-by-category',
    path: '/retail-reports/margin-by-category',
    name: 'Biên lợi nhuận ngành hàng',
    permission: 'SL_RETAIL_ANALYTICS_VIEW',
    menuIcon: 'fi fi-rr-chart-pie-alt',
    subtitle: 'Doanh số bán lẻ từ phần hàng đã xuất kho và dịch vụ hợp lệ.',
    filters: [], metrics: [], panels: [],
  },
  {
    id: 'sku-and-slow-moving',
    path: '/retail-reports/sku-and-slow-moving',
    name: 'Top SKU & bán chậm',
    permission: 'SL_RETAIL_ANALYTICS_VIEW',
    menuIcon: 'fi fi-rr-package',
    subtitle: 'Doanh số bán lẻ từ phần hàng đã xuất kho và dịch vụ hợp lệ.',
    filters: [], metrics: [], panels: [],
  },
  {
    id: 'inventory-aging',
    path: '/retail-reports/inventory-aging',
    name: 'Tồn kho & tuổi tồn',
    permission: 'SL_RETAIL_ANALYTICS_VIEW',
    menuIcon: 'fi fi-rr-boxes',
    subtitle: 'Doanh số bán lẻ từ phần hàng đã xuất kho và dịch vụ hợp lệ.',
    filters: [], metrics: [], panels: [],
  },
  {
    id: 'replenishment-forecast',
    path: '/retail-reports/replenishment-forecast',
    name: 'Bổ sung hàng & dự báo mua',
    permission: 'SL_RETAIL_ANALYTICS_VIEW',
    menuIcon: 'fi fi-rr-shopping-cart',
    subtitle: 'Doanh số bán lẻ từ phần hàng đã xuất kho và dịch vụ hợp lệ.',
    filters: [], metrics: [], panels: [],
  },
  {
    id: 'promotion-and-basket',
    path: '/retail-reports/promotion-and-basket',
    name: 'Khuyến mại & bán kèm',
    permission: 'SL_RETAIL_ANALYTICS_VIEW',
    menuIcon: 'fi fi-rr-ticket',
    subtitle: 'Doanh số bán lẻ từ phần hàng đã xuất kho và dịch vụ hợp lệ.',
    filters: [], metrics: [], panels: [],
  },
  {
    id: 'returns-and-defects',
    path: '/retail-reports/returns-and-defects',
    name: 'Đổi trả & lỗi sản phẩm',
    permission: 'SL_RETAIL_ANALYTICS_VIEW',
    menuIcon: 'fi fi-rr-repeat',
    subtitle: 'Doanh số bán lẻ từ phần hàng đã xuất kho và dịch vụ hợp lệ.',
    filters: [], metrics: [], panels: [],
  },
  {
    id: 'loyalty-and-cohort',
    path: '/retail-reports/loyalty-and-cohort',
    name: 'Khách hàng thân thiết & cohort',
    permission: 'SL_RETAIL_ANALYTICS_VIEW',
    menuIcon: 'fi fi-rr-user',
    subtitle: 'Doanh số bán lẻ từ phần hàng đã xuất kho và dịch vụ hợp lệ.',
    filters: [], metrics: [], panels: [],
  },
  {
    id: 'cashier-and-shifts',
    path: '/retail-reports/cashier-and-shifts',
    name: 'Thu ngân & hiệu suất ca',
    permission: 'SL_RETAIL_ANALYTICS_VIEW',
    menuIcon: 'fi fi-rr-credit-card',
    subtitle: 'Doanh số bán lẻ từ phần hàng đã xuất kho và dịch vụ hợp lệ.',
    filters: [], metrics: [], panels: [],
  },
  {
    id: 'debt-and-cashflow',
    path: '/retail-reports/debt-and-cashflow',
    name: 'Công nợ & dòng tiền',
    permission: 'SL_RETAIL_ANALYTICS_VIEW',
    menuIcon: 'fi fi-rr-calculator',
    subtitle: 'Doanh số bán lẻ từ phần hàng đã xuất kho và dịch vụ hợp lệ.',
    filters: [], metrics: [], panels: [],
  },
  {
    id: 'supplier-and-leadtime',
    path: '/retail-reports/supplier-and-leadtime',
    name: 'Nhà cung cấp & lead time',
    permission: 'SL_RETAIL_ANALYTICS_VIEW',
    menuIcon: 'fi fi-rr-truck-side',
    subtitle: 'Doanh số bán lẻ từ phần hàng đã xuất kho và dịch vụ hợp lệ.',
    filters: [], metrics: [], panels: [],
  },
  {
    id: 'omnichannel-conversion',
    path: '/retail-reports/omnichannel-conversion',
    name: 'Omnichannel & chuyển đổi',
    permission: 'SL_RETAIL_ANALYTICS_VIEW',
    menuIcon: 'fi fi-rr-globe',
    subtitle: 'Doanh số bán lẻ từ phần hàng đã xuất kho và dịch vụ hợp lệ.',
    filters: [], metrics: [], panels: [],
  },
  {
    id: 'sales-staff-productivity',
    path: '/retail-reports/sales-staff-productivity',
    name: 'Bán hàng theo nhân viên bán hàng',
    permission: 'SL_RETAIL_SALES_STAFF_PRODUCTIVITY_VIEW',
    menuIcon: 'fi fi-rr-users-alt',
    subtitle: 'Đánh giá năng lực bán của từng nhân viên theo doanh thu, số đơn và tỷ lệ bán kèm.',
    filters: [
      { label: 'Khối', value: 'Showroom' },
      { label: 'Vai trò', value: 'Nhân viên bán hàng' },
      { label: 'Kỳ', value: '30 ngày' },
      { label: 'Chỉ số', value: 'Doanh thu + đơn + bán kèm' },
    ],
    metrics: [
      { label: 'Doanh thu/người', value: '1,26 tỷ', delta: '+9,4%', tone: 'positive', note: 'trong 30 ngày' },
      { label: 'Attach rate', value: '33,1%', delta: '+4,0 điểm', tone: 'positive', note: 'bán kèm phụ kiện' },
      { label: 'Tỷ lệ chốt', value: '27,6%', delta: '+1,2 điểm', tone: 'positive', note: 'tư vấn -> hóa đơn' },
      { label: 'NPS sau bán', value: '68', delta: '+5 điểm', tone: 'positive', note: 'từ survey hậu mãi' },
    ],
    panels: [
      {
        type: 'leaderboard',
        width: 'span-4',
        title: 'Top sales advisor',
        subtitle: 'Theo doanh thu và margin.',
        items: [
          { label: 'Lê Minh Anh', value: '2,14 tỷ', meta: 'GM 25,8% | Attach 41%' },
          { label: 'Nguyễn Trọng Nam', value: '1,98 tỷ', meta: 'GM 24,9% | Attach 38%' },
          { label: 'Hoàng Thu Hà', value: '1,82 tỷ', meta: 'GM 26,2% | Attach 36%' },
          { label: 'Bùi Hải Đăng', value: '1,71 tỷ', meta: 'GM 23,4% | Attach 34%' },
        ],
      },
      {
        type: 'bars',
        width: 'span-4',
        title: 'Attach rate theo cá nhân',
        subtitle: 'Bán kèm trên hóa đơn.',
        bars: [
          { label: 'Minh Anh', value: 41, color: '#ED3237' },
          { label: 'Trọng Nam', value: 38, color: '#FF6B6F' },
          { label: 'Thu Hà', value: 36, color: '#F79009' },
          { label: 'Hải Đăng', value: 34, color: '#12B76A' },
          { label: 'Nhóm còn lại', value: 29, color: '#344054' },
        ],
      },
      {
        type: 'table',
        width: 'span-4',
        title: 'Nhân sự cần coaching',
        subtitle: 'Dựa trên chốt đơn và NPS.',
        columns: ['Nhân sự', 'Doanh thu', 'Chốt đơn', 'NPS'],
        rows: [
          ['A. Dương', '880 triệu', '19%', '54'],
          ['K. Huyền', '910 triệu', '21%', '57'],
          ['M. Linh', '960 triệu', '22%', '59'],
          ['T. Quỳnh', '1,02 tỷ', '20%', '52'],
        ],
      },
    ],
  },
  {
    id: 'inventory-sales-by-store',
    path: '/retail-reports/inventory-sales-by-store',
    name: 'Tồn kho và xuất bán theo chi nhánh',
    permission: 'SL_RETAIL_INVENTORY_SALES_BY_STORE_VIEW',
    menuIcon: 'fi fi-rr-box-open',
    subtitle: 'Tổng hợp tồn cuối kỳ và số lượng xuất bán thực tế của các chi nhánh theo khoảng ngày tùy chọn.',
    filters: [],
    metrics: [],
    panels: [],
  },
  {
    id: 'transactions',
    path: '/retail-reports/transactions',
    name: 'Chi tiết giao dịch bán hàng',
    permission: 'SL_SALES_REPORT_TRANSACTION_VIEW',
    menuIcon: 'fi fi-rr-receipt',
    subtitle: 'Đối chiếu từng dòng sản phẩm và tách riêng người bán, người tạo đơn, thu ngân.',
    filters: [],
    metrics: [],
    panels: [],
  },
  {
    id: 'employee-monthly-income',
    path: '/retail-reports/employee-monthly-income',
    name: 'Thu nhập và doanh số nhân viên',
    permission: 'SL_RETAIL_EMPLOYEE_MONTHLY_INCOME_VIEW',
    menuIcon: 'fi fi-rr-user-salary',
    subtitle: 'Tổng hợp doanh số, hoa hồng tự động và các khoản nghiệp vụ phát sinh theo nhân viên trong tháng.',
    filters: [],
    metrics: [],
    panels: [],
  },
  {
    id: 'employee-product-sales',
    path: '/retail-reports/employee-product-sales',
    name: 'Bán hàng theo nhân viên và hàng hóa',
    permission: 'SL_RETAIL_EMPLOYEE_PRODUCT_SALES_VIEW',
    menuIcon: 'fi fi-rr-users-alt',
    subtitle: 'Doanh thu và trả hàng theo nhân viên bán hàng, mở chi tiết theo từng hàng hóa.',
    filters: [], metrics: [], panels: [],
  },
  {
    id: 'product-sales',
    path: '/retail-reports/product-sales',
    name: 'Bán hàng theo hàng hóa',
    permission: 'SL_RETAIL_PRODUCT_SALES_VIEW',
    menuIcon: 'fi fi-rr-box-open',
    subtitle: 'Số lượng bán, doanh thu, trả hàng và doanh thu thuần trước VAT theo hàng hóa.',
    filters: [], metrics: [], panels: [],
  },
];

export const getRetailReportPermissions = (report = {}) =>
  [report.permission, ...(report.fallbackPermissions || [])].filter(Boolean);

export const getRetailReportByPath = (pathname = '') =>
  RETAIL_REPORTS.find((item) => pathname === item.path) || RETAIL_REPORTS[0];
